<template>
  <v-stepper v-model="step">
    <v-stepper-header>
      <v-stepper-step :complete="step > 1" step="1"></v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step > 2" step="2"></v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step > 3" step="3"></v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step > 4" step="4"></v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="5"></v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <!-----------------tela 1------------------------->
      <v-stepper-content step="1" class="pa-0">
        <v-card>
          <v-img :src="require('@/assets/banner.svg')" contain></v-img>
          <v-card-text class="pt-4" style="position: relative;">
            <div class="font-weight-light grey--text title mb-2">Parabéns</div>
            <h3 class="display-1 font-weight-light orange--text mb-2">Bem vindo à Apetrus</h3>
            <div class="font-weight-light title mb-2">
              Agora você tem um veículo poderoso.
              <br />Para alcançar os motoristas de sua cidade com suas ofertas.
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="step = 2">Começar</v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <!-----------------fim tela 1------------------------->
      <!-----------------tela 2------------------------->
      <v-stepper-content step="2" class="pa-0">
        <cad-posto></cad-posto>
      </v-stepper-content>

      <v-stepper-content step="3" class="pa-0">
        <v-card>
          <v-card-text class="pt-4" style="position: relative;">
            <h4
              class="display-1 font-weight-light orange--text mb-4"
            >Concorde com os termos para prosseguir.</h4>
            <v-layout row wrap justify-space-around fill-height>
              <v-flex xs12>
                <v-btn color="primary" block outline @click="dialogTermosUso = true">
                  <v-icon :color="termosLidos? 'green' : 'grey'">check_circle</v-icon>
                  <v-spacer></v-spacer>Termos de Uso
                  <v-spacer></v-spacer>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-btn color="primary" block outline @click="dialogPoliticasPrivacidade = true">
                  <v-icon :color="politicasLidas? 'green' : 'grey'">check_circle</v-icon>
                  <v-spacer></v-spacer>Política de privacidade
                  <v-spacer></v-spacer>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              flat
              :disabled="!(termosLidos && politicasLidas)"
              color="primary"
              @click="aceitarTermos"
            >Concordar</v-btn>
          </v-card-actions>
        </v-card>
        <v-dialog
          v-model="dialogTermosUso"
          width="600"
          persistent
          :fullscreen="$vuetify.breakpoint.xs"
        >
          <termos-de-uso @fechar="dialogTermosUso = false" @confirmarLeitura="termosLidos = true"></termos-de-uso>
        </v-dialog>
        <v-dialog
          v-model="dialogPoliticasPrivacidade"
          width="600"
          persistent
          :fullscreen="$vuetify.breakpoint.xs"
        >
          <politica-de-privacidade
            @fechar="dialogPoliticasPrivacidade = false"
            @confirmarLeitura="politicasLidas = true"
          ></politica-de-privacidade>
        </v-dialog>
      </v-stepper-content>
      <!-----------------fim tela 2------------------------->

      <v-stepper-content step="4" class="pa-0">
        <geo-position v-if="step===4"></geo-position>
      </v-stepper-content>
      <!-----------------tela 4------------------------->

      <v-stepper-content step="5" class="pa-0">
        <precificar-posto v-if="step===5"></precificar-posto>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import CadPosto from '@/components/cadastros/CadPosto'
import TermosDeUso from '@/components/dialogs/DialogTermosUso'
import PoliticaDePrivacidade from '@/components/dialogs/DialogPoliticaPrivacidade'
import GeoPosition from '@/components/cadastros/GeoPosition'
import PrecificarPosto from '@/components/cadastros/PrecificarPosto'
import { postosDao } from '@/api'

export default {
  components: {
    CadPosto,
    GeoPosition,
    PrecificarPosto,
    TermosDeUso,
    PoliticaDePrivacidade
  },
  props: ['visible'],
  data () {
    return {
      step: 0,
      confirmGeoposition: false,
      termosLidos: false,
      politicasLidas: false,
      dialogTermosUso: false,
      dialogPoliticasPrivacidade: false
    }
  },
  watch: {
    posto (val) {
      if (val !== null && val !== undefined) {
        if (val.geoposition && this.step === 4) {
          this.step++
        }
        if (val.precificado && this.step === 5) {
          this.$emit('finalizado')
        }
      }
    },
    postos (val) {
      if (val !== null && val !== undefined && val.length > 0) {
        if (this.step === 2) {
          this.step++
        }
      }
    },
    step (val) {
      if (val === 2 && this.postos.length) {
        this.step++
      }
      if (val === 3 && this.posto.termos_aceitos) {
        this.step++
      }
      if (val === 4 && this.posto.geoposition) {
        this.step++
      }
      if (val === 5 && this.posto.precificado) {
        this.$emit('finalizado')
      }
    }
  },
  computed: {
    postos () {
      return this.$store.getters.postos
    },
    posto () {
      return this.$store.getters.posto
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  methods: {
    aceitarTermos () {
      postosDao.aceitarTermos(this.posto.cnpj, this.headers).then(() => {
        this.$store.dispatch('aceitarTermos')
        this.step = 4
      })
    }
  }
}
</script>
